import styles from "./styles.module.scss";
import { useContext, useEffect, useState } from "react";

import { PopconfirmProps } from "./types";
import { TranslationContext } from "../../../../contexts/translation/index.context";
import { FormProvider } from "../../../../contexts/form/index.context";
//Components
import ModalEmail from "../modal-select-mail";
import ModalTable from "./modal";
//Icons
import DownloadOutlined  from "@ant-design/icons/DownloadOutlined";
//UI
import Space from "antd/lib/space";

export default function PopconfirmComponent(props: PopconfirmProps) {
  const [selectedEmail, setSelectedEmail] = useState<string | null>(null);

  return (
    <>
      <ModalEmail
        name={"incoming-mail-download-files-from-mailbox"}
        buttonText={"incoming-mail-download-files-from-mailbox"}
        setEmail={setSelectedEmail}
        // icon={<DownloadOutlined />}
      />
      <Space >
        <ModalTable
          name={"incoming-mail-download-files-from-mailbox"}
          email={selectedEmail}
          setEmail={setSelectedEmail}
        />
      </Space>
    </>
  );
}
